<template>
  <div id="app">
    <transition :name="transitionName">
      <router-view v-if="firstloading" class="child-view"></router-view>
    </transition>
  </div>
</template>
<script>
import Vue from "vue";
import wx from "weixin-js-sdk";
import config from '@/config';
export default {
  name: "app",
  data() {
    return {
      firstloading: false,
      transitionName: "slide-left"
    };
  },
  //监听路由的路径，可以通过不同的路径去选择不同的切换效果
  watch: {
    $route(to, from) {
      if (to.path == "/") {
        this.transitionName = "slide-right";
      } else {
        this.transitionName = "slide-left";
      }
    }
  },
  methods: {
    //获得自定义的配置文件信息
    getConfig(callback) {
      var t = this;
      var url = `./h_config.json?d=` + new Date().valueOf();
      var params = {};
      t.$http
        .get(url, params)
        .then(res => {
          var config = {};
          try {
            config = res.data;
          } catch (error) {
            console.log("config format error", res);
          }
          typeof callback == "function" && callback(config);
        })
        .catch(error => {
          typeof callback == "function" && callback(null, error);
        });
    },
    //获得APP内的用户信息
    getAppUserInfo(callback) {
      var t = this;
      setTimeout(function() {
        var userInfo = "";
        try {
          userInfo = Jegotrip.getUserInfo();
        } catch (e) {}

        console.log("userInfo:Jegotrip.getUserInfo()");
        console.log(userInfo);
        if (userInfo) {
          userInfo = JSON.parse(userInfo);
          typeof callback == "function" && callback(userInfo);
        } else {
          // loading.clear();
          if (t.loop < 3) {
            t.loop++;
            console.log("循环请求次数：" + t.loop);
            t.getAppUserInfo(callback);
          } else {
            t.loop = 0;
            typeof callback == "function" && callback(null, "no token");
          }
        }
        // t.getteams(t.urlData.token, t.urlData.openid);
        // t.getTeamAwards(t.urlData.openid);
      }, 200 + t.loop * 200);
    },
    
  },
  components: {},
  created() {},
  mounted() {
    var t = this;
    t.getConfig((res, error) => {
      console.log("getconfig res", res);
      console.log("getconfig error", error);
      if (res && res.baseurl) {
        console.log("getconfig baseurl", res.baseurl);
        Vue.prototype.baseurl = res.baseurl;
      }
      if (res && res.debug && res.debug == 1) {
        require("./assets/util/vconsole.js");
      }
      t.firstloading = true;

      t.urlData = t._keyUrl();
      var q = t.$route.query;
      if (q.a) t.urlData = q;

      //1、初始化全局参数
      var app_params =  { 
        share_userid: 0, 
        activity_id: config.default_aid,
        channel:"0"
      };
      //2、获取历史缓存
      var app_params_cache = localStorage.getItem(config.app_params_key);
      if(app_params_cache && app_params_cache.length>0)
        app_params = JSON.parse(app_params_cache);
      //3、替换新传入的参数
      var new_params = {};
      //3.1、从url中取参数的情况
      if(t.urlData && Object.keys(t.urlData).length>0)
        new_params = t.urlData;
      //3.2、如果url中没有参数，可能是授权过程丢失参数，所以从授权前的login_redirect中获得参数
      //（ps1:假设页面a页面带参数，但需要授权，会被路由阻止进入app.vue。直接跳转登陆页面，登陆页面本身也会先进app.vue,登陆页面可能是不带需要更新的参数的。但是确可能需要用到这些参数。所以在这里取一下登陆前的参数）
      //（ps2:假设页面a页面带参数，但需要授权，会被路由阻止进入app.vue。直接跳转登陆页面，登陆完后跳转回来的时候可能会丢失这个参数）
      else{
        var login_redirect = localStorage.getItem("login_redirect");
        if (login_redirect) {
          login_redirect = JSON.parse(login_redirect);
          if (login_redirect.query && Object.keys(login_redirect.query).length>0)
          new_params = login_redirect.query;
        }
      }
      if(new_params.sid) app_params.share_userid = new_params.sid;
      if(new_params.a) app_params.activity_id =new_params.a;
      if(new_params.channel) app_params.channel = new_params.channel;
      //4、更新缓存
      localStorage.setItem(config.app_params_key, JSON.stringify(app_params));
      //5、打印全局参数当前值
      console.log("now app_params",app_params);

      // // 页面重定向进来后，share_userid可能有有缓存，所以不能重新赋值
      // var app_params = localStorage.getItem(config.app_params_key);
      // try {
      //   app_params = JSON.parse(app_params);
      // } catch (e) {}
      // if (app_params && app_params.share_userid) {
      //   app_params.share_userid;
      //   console.log("----"，config.app_params_key);
      //   console.log(app_params);
      // } else {
      //   app_params = { share_userid: 0, activity_id: 2 };
      // }
      // //如果有分享用户id，存入缓存
      // if (t.urlData.sid)
      //   app_params = { share_userid: t.urlData.sid, activity_id: t.urlData.a,channel:t.urlData.channel ? t.urlData.channel : '0'};
      // //如果页面参数没有，可能是在跳转页面，初始界面的缓存里面肯定会有这个sid
      // else {
      //   var login_redirect = localStorage.getItem("login_redirect");
      //   console.log(
      //     " wxloginresult login_redirect ",
      //     localStorage.getItem("login_redirect")
      //   );
      //   if (login_redirect) {
      //     login_redirect = JSON.parse(login_redirect);
      //     if (login_redirect.query && login_redirect.query.sid)
      //       app_params = {
      //         share_userid: login_redirect.query.sid,
      //         activity_id: login_redirect.query.a,
      //         channel:login_redirect.query.channel ? login_redirect.query.channel : '0'
      //       };
      //   }
      // }
      // localStorage.setItem(config.app_params_key, JSON.stringify(app_params));
      console.log("***t.urlData-app***:", t.urlData);
      console.log("***window.location.href***:", window.location.href);
      // // 如果是分享链接点进来的，需要授权
      // if (t.urlData.isauth == 1) {
      //   t.getAuthorizationUrl();
      // }

      if (t._getBrowser() == 2) {
        //初始化微信JSSDK
        t._getJSConfig();
      }
      //如果在app内，先通过app页面接口获得用户信息
      else if (t._getBrowser() == 1) {
        var login_info = t._getLoginInfo();
        if (login_info) {
          t.getAppUserInfo((userinfo, err) => {
            if (!err) {
              //如果在app页面接口获取的用户信息与 app_login_user 中的用户信息不一致，则删除app_login_user信息，跳转登录页面

              if (
                !login_info ||
                !login_info.mobile ||
                login_info.mobile != userinfo.mobile
              )
                t.login_exp();
            }
            //无法通过页面接口获取用户信息的情况
            else t.login_exp();
          });
        }
      }
      console.log("当前版本：" + t.version);
    });
  }
};
</script>
<style lang="scss">
@import url(../static/css/app_all.css);
@import url(../static/css/base.css);
@import "../static/scss/var.scss";
body {
  background: #45d4e8;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.van-notice-bar {
  height: auto;
}
.common-bg {
  width: vw(400);
  height: vw(60);
  line-height: vw(60);
  background: linear-gradient(
    -90deg,
    rgba(255, 92, 147, 1),
    rgba(255, 176, 208, 1)
  );
  box-shadow: 0px vw(5) vw(10) 0px rgba(220, 30, 94, 0.3);
  border-radius: vw(30);
  font-size: vw(28);
  color: #fff;
  text-align: center;
  margin: 0 auto;
}

.child-view {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  transition: all 0.8s cubic-bezier(0.55, 0, 0.1, 1);
}
.slide-left-enter,
.slide-right-leave-active {
  opacity: 0;
  -webkit-transform: translate(60px, 0);
  transform: translate(60px, 0);
}
.slide-left-leave-active,
.slide-right-enter {
  opacity: 0;
  -webkit-transform: translate(-60px, 0);
  transform: translate(-60px, 0);
}
.ditch-logo02{
  width: vw(175);
  height: vw(24);
  position: absolute;
  left: vw(166);
  top: vw(45);
  z-index: 22;
}
</style>
